module.exports = __webpack_public_path__ + "static/media/sundorbon.895e9439.png";